import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { InitializeSelectors } from './+state/initialize.selectors';

@Injectable()
export class RouterStoreService {
  private readonly store = inject(Store);

  public readonly previousRoute = this.store.selectSignal(InitializeSelectors.previousRoute);

  public readonly previousRouteUrlTree = this.store.selectSignal(
    InitializeSelectors.previousRouteUrlTree,
  );

  public readonly previousRoutePrimaryNavigationPath = this.store.selectSignal(
    InitializeSelectors.previousRoutePrimaryNavigationPath,
  );

  public readonly currentRoute = this.store.selectSignal(InitializeSelectors.currentRoute);

  public readonly currentRouteUrlTree = this.store.selectSignal(
    InitializeSelectors.currentRouteUrlTree,
  );

  public readonly currentRoutePrimaryNavigationPath = this.store.selectSignal(
    InitializeSelectors.currentRoutePrimaryNavigationPath,
  );

  public readonly params = this.store.selectSignal(InitializeSelectors.nestedParams);

  public readonly queryParams = this.store.selectSignal(InitializeSelectors.nestedQueryParams);

  public readonly data = this.store.selectSignal(InitializeSelectors.nestedData);

  public selectParam(key: string): Signal<string | undefined> {
    return this.store.selectSignal(InitializeSelectors.selectRouteNestedParam(key));
  }

  public selectQueryParam<T>(key: string): Signal<T | undefined> {
    return this.store.selectSignal(InitializeSelectors.selectRouteNestedQueryParam<T>(key));
  }

  public selectData<T>(key: string): Signal<T | undefined> {
    return this.store.selectSignal(InitializeSelectors.selectRouteNestedDataKey<T>(key));
  }
}
